export const colors = {
  primary: '#215684',
  blackBG: '#252324',
  whiteBG: '#F0FAFE',
  whiteFont: `rgb(${202},${221},${230})`,
  border: '#e8eaf6',
}
